import classnames from 'classnames';
import LastUsedToolTip from 'modules/authentication/components/LastUsedToolTip';
import EmailIcon from 'modules/host-profile/components/ContactDetails/icons/EmailIcon';
import React from 'react';
import capitalizeString from 'utils/textHelpers/capitalizeString';
import AppleIcon from '~/reusable-components/icons/social/AppleIcon';
import FacebookIcon from '~/reusable-components/icons/social/FacebookIcon';
import GoogleColorIcon from '~/reusable-components/icons/social/GoogleColorIcon';

const CSS = require('./AuthButton.module.scss');

export type AuthProvider = 'google' | 'facebook' | 'apple' | 'email';

interface AuthButtonProps {
  onClick: (provider: AuthProvider) => void;
  provider: AuthProvider;
  variant?: 'compact' | 'large';
  isLoading?: boolean;
  hasError?: boolean;
  isLastUsed?: boolean;
}

function AuthButton({
  onClick,
  provider,
  variant = 'compact',
  isLoading,
  hasError,
  isLastUsed,
}: AuthButtonProps) {
  const onButtonClick = () => onClick(provider);
  const buttonText = `Continue with ${capitalizeString(provider)}`;

  return (
    <div className={CSS.ButtonContainer}>
      <button
        data-test-id={`AuthButton-${provider}`}
        className={classnames(CSS.Button, {
          [CSS.AppleButton]: provider === 'apple',
          [CSS.FacebookButton]: provider === 'facebook',
          [CSS.GoogleButton]: provider === 'google',
          [CSS.EmailButton]: provider === 'email',
          [CSS.ButtonLoading]: isLoading,
          [CSS.ButtonFullWidth]: variant === 'large',
          [CSS.ButtonError]: hasError,
          [CSS.LastUsedButton]: isLastUsed,
        })}
        onClick={onButtonClick}
        aria-label={buttonText}
      >
        {provider === 'google' && (
          <GoogleColorIcon className={CSS.Icon} width={24} height={24} />
        )}
        {provider === 'facebook' && (
          <FacebookIcon
            className={classnames(CSS.Icon, CSS.FacebookIcon)}
            width={30}
            height={30}
          />
        )}
        {provider === 'apple' && (
          <AppleIcon
            className={classnames(CSS.Icon, CSS.AppleIcon)}
            width={24}
            height={24}
          />
        )}
        {provider === 'email' && (
          <EmailIcon
            className={classnames(CSS.Icon, CSS.EmailIcon)}
            width={24}
            height={24}
          />
        )}
        {variant === 'large' && (
          <span className={CSS.ButtonText}>{buttonText}</span>
        )}
      </button>
      {isLastUsed && <LastUsedToolTip variant="oauth" />}
    </div>
  );
}

export default AuthButton;
